import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0cb49c04"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pan-wrap"
};
const _hoisted_2 = {
  class: "pan-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pan-title"
}, "📊 盘口走势", -1));
const _hoisted_4 = {
  key: 1,
  class: "pan-id"
};
const _hoisted_5 = {
  key: 0,
  class: "pan-overview"
};
const _hoisted_6 = {
  class: "seg"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "ov-card-top"
};
const _hoisted_10 = {
  class: "ov-card-name"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ov-dot"
}, null, -1));
const _hoisted_12 = {
  class: "ov-card-time"
};
const _hoisted_13 = {
  class: "ov-card-values"
};
const _hoisted_14 = {
  class: "ov-label"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ov-card-foot"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "ov-tip"
}, "查看历史变动"), /*#__PURE__*/_createElementVNode("span", {
  class: "ov-arrow"
}, "›")], -1));
const _hoisted_16 = {
  key: 1,
  class: "pan-empty"
};
const _hoisted_17 = {
  key: 1,
  class: "pan-body"
};
const _hoisted_18 = {
  class: "pan-side"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "pan-main"
};
const _hoisted_21 = {
  class: "seg"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  key: 0,
  class: "pan-current"
};
const _hoisted_24 = {
  class: "pan-current-head"
};
const _hoisted_25 = {
  class: "pan-current-tag"
};
const _hoisted_26 = {
  class: "pan-current-time"
};
const _hoisted_27 = {
  class: "pan-cols"
};
const _hoisted_28 = {
  class: "pan-current-label"
};
const _hoisted_29 = {
  key: 1,
  class: "pan-list"
};
const _hoisted_30 = {
  class: "pan-row pan-row-head"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pan-time"
}, "时间", -1));
const _hoisted_32 = {
  class: "pan-cols"
};
const _hoisted_33 = {
  class: "pan-time"
};
const _hoisted_34 = {
  class: "pan-cols"
};
const _hoisted_35 = {
  key: 1,
  class: "pan-empty"
};
import { ref, computed } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
import HandicapTrendView from './HandicapTrendView.vue';
export default {
  __name: 'HandicapView',
  setup(__props, {
    expose: __expose
  }) {
    const isListVisible = ref(false);
    const trendRef = ref(null); // 全屏走势弹层
    const viewMode = ref('overview'); // overview 总览 / detail 明细
    const active = ref(0); // 市场：0亚盘 / 1欧盘 / 2大小
    const companyActive = ref(0); // 明细中的公司索引
    const overviewData = ref({}); // { [公司索引]: [亚盘[], 欧盘[], 大小[]] }
    const loading = ref(false);
    const id = ref('');

    // 公司（名称 + 后端 companyId）
    const companies = [{
      name: '皇冠',
      id: 3
    }, {
      name: '365',
      id: 2
    }, {
      name: '澳门',
      id: 7
    }, {
      name: '威廉希尔',
      id: 9
    }, {
      name: '香港马会',
      id: 136
    }];

    // 三市场列配置：key 对应 value 字段编号（value2/3/4）
    const markets = [{
      name: '亚盘',
      cols: [{
        label: '主',
        key: 2,
        trend: true
      }, {
        label: '盘口',
        key: 3,
        handicap: true
      }, {
        label: '客',
        key: 4,
        trend: true
      }]
    }, {
      name: '欧盘',
      cols: [{
        label: '胜',
        key: 2,
        trend: true
      }, {
        label: '平',
        key: 3,
        trend: true
      }, {
        label: '负',
        key: 4,
        trend: true
      }]
    }, {
      name: '大小',
      cols: [{
        label: '大',
        key: 2,
        trend: true
      }, {
        label: '盘口',
        key: 3,
        handicap: true
      }, {
        label: '小',
        key: 4,
        trend: true
      }]
    }];
    const currentMarket = computed(() => markets[active.value]);
    const currentCols = computed(() => currentMarket.value.cols);

    // 拉取某家公司三市场盘口
    const fetchOdds = async (matchId, companyId) => {
      const url = 'https://tuhaojie.asia/api-foot/matchGoalWater/selectCompanyOdds?id=' + matchId + '&company=' + companyId;
      const response = await axios.get(url);
      return response.data;
    };

    // 加载指定公司数据（无缓存时）
    const loadCompany = i => {
      if (overviewData.value[i]) return;
      loading.value = true;
      fetchOdds(id.value, companies[i].id).then(d => {
        overviewData.value[i] = d;
      }).catch(() => {
        overviewData.value[i] = null;
      }).finally(() => {
        loading.value = false;
      });
    };
    const show = matchId => {
      isListVisible.value = true;
      id.value = matchId;
      viewMode.value = 'overview';
      active.value = 0;
      companyActive.value = 0;
      overviewData.value = {};
      loading.value = true;
      Promise.all(companies.map((c, i) => fetchOdds(matchId, c.id).then(d => {
        overviewData.value[i] = d;
      }))).catch(() => {
        showNotify.warn('部分盘口数据加载失败', {
          duration: 2000
        });
      }).finally(() => {
        loading.value = false;
      });
    };
    const close = () => {
      isListVisible.value = false;
    };
    const selectMarket = i => {
      active.value = i;
    };

    // 总览 → 进入某公司明细
    const enterDetail = i => {
      companyActive.value = i;
      viewMode.value = 'detail';
      loadCompany(i);
    };
    const backToOverview = () => {
      viewMode.value = 'overview';
    };

    // 明细内切换公司
    const selectCompany = i => {
      companyActive.value = i;
      loadCompany(i);
    };

    // 打开当前市场走势折线图，携带全部机构数据以便全屏内对比叠加
    const openTrend = () => {
      const asc = list => list.slice().sort((a, b) => String(a.value1).localeCompare(String(b.value1)));
      const mainData = overviewData.value[companyActive.value];
      const mainRows = mainData && mainData[active.value] || [];
      if (asc(mainRows).length < 2) {
        showNotify.warn('变动点太少，暂无法绘制走势图', {
          duration: 2000
        });
        return;
      }
      const payloadCompanies = companies.map((c, i) => {
        const d = overviewData.value[i];
        const raw = d && d[active.value] || [];
        return {
          name: c.name,
          rows: asc(raw)
        };
      });
      trendRef.value.show({
        marketIndex: active.value,
        main: companies[companyActive.value].name,
        companies: payloadCompanies
      });
    };

    // ===== 总览数据 =====
    // 不依赖后端返回顺序：按 value1(yyyy-MM-dd HH:mm) 降序，最新在前
    const sortDesc = list => list.slice().sort((a, b) => String(b.value1).localeCompare(String(a.value1)));
    const overviewRows = computed(() => companies.map((c, i) => {
      const d = overviewData.value[i];
      const raw = d && d[active.value] ? d[active.value] : [];
      const sorted = sortDesc(raw);
      return {
        name: c.name,
        list: sorted,
        hasData: !!sorted.length
      };
    }));
    const latestOf = (row, col) => {
      const cur = row.list.length ? row.list[0] : null;
      return cur ? getVal(cur, col) : '-';
    };
    const latestTimeOf = row => {
      const cur = row.list.length ? row.list[0] : null;
      return cur ? fmtTime(cur.value1) : '';
    };
    // 总览卡片数值着色：主/胜/大 红，客/负/小 蓝，平 橙，盘口 金
    const valColor = c => {
      if (c.handicap) return 'ov-gold';
      if (c.label === '主' || c.label === '胜' || c.label === '大') return 'ov-home';
      if (c.label === '客' || c.label === '负' || c.label === '小') return 'ov-away';
      if (c.label === '平') return 'ov-draw';
      return '';
    };

    // ===== 明细数据 =====
    const currentList = computed(() => {
      const d = overviewData.value[companyActive.value];
      const raw = d && d[active.value] ? d[active.value] : [];
      return sortDesc(raw);
    });
    const current = computed(() => currentList.value[0] || null);
    const historyList = computed(() => currentList.value.slice(1));

    // 时间格式化："2026-08-31 12:30" -> "08-31 12:30"
    const fmtTime = v1 => {
      if (!v1) return '';
      const p = String(v1).split(' ');
      const d = (p[0] || '').slice(5);
      const t = (p[1] || '').slice(0, 5);
      return (d + (t ? ' ' + t : '')).trim();
    };
    const getVal = (item, col) => {
      const raw = item['value' + col.key];
      if (col.key === 3 && active.value === 2) {
        return String(raw || '').replace('球', '');
      }
      return raw;
    };

    // 与更旧的一条（历史列表中的下一条）比较涨跌：涨红▲ / 跌绿▼
    const trendOf = (i, col) => {
      const next = historyList.value[i + 1];
      if (!next || !col.trend) return 'none';
      const a = Number(historyList.value[i]['value' + col.key]);
      const b = Number(next['value' + col.key]);
      if (isNaN(a) || isNaN(b)) return 'none';
      return a > b ? 'up' : a < b ? 'down' : 'none';
    };

    // eslint-disable-next-line no-undef
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_popup, {
        visible: isListVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isListVisible.value = $event),
        closeable: "",
        style: {
          padding: '0',
          height: '85%',
          width: '92%',
          overflow: 'hidden'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, viewMode.value === 'detail' ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "pan-back",
          onClick: backToOverview
        }, "← 总览")) : id.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, "比赛 " + _toDisplayString(id.value), 1)) : _createCommentVNode("", true)]), viewMode.value === 'overview' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(markets, (m, i) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["seg-item", {
              active: active.value === i
            }]),
            key: m.name,
            onClick: $event => selectMarket(i)
          }, _toDisplayString(m.name), 11, _hoisted_7);
        }), 64))]), _createVNode(_component_var_loading, {
          loading: loading.value,
          description: "加载中"
        }, {
          default: _withCtx(() => [overviewRows.value.some(r => r.hasData) ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(overviewRows.value, (row, i) => {
            return _openBlock(), _createElementBlock("div", {
              class: "ov-card",
              key: row.name,
              onClick: $event => enterDetail(i)
            }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, [_hoisted_11, _createTextVNode(_toDisplayString(row.name), 1)]), _createElementVNode("span", _hoisted_12, _toDisplayString(latestTimeOf(row)), 1)]), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCols.value, c => {
              return _openBlock(), _createElementBlock("div", {
                class: "ov-col",
                key: c.key
              }, [_createElementVNode("span", {
                class: _normalizeClass(["ov-val", valColor(c)])
              }, _toDisplayString(latestOf(row, c)), 3), _createElementVNode("span", _hoisted_14, _toDisplayString(c.label), 1)]);
            }), 128))]), _hoisted_15], 8, _hoisted_8);
          }), 128)) : !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, "暂无盘口数据")) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["loading"])])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(companies, (c, i) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["pan-company", {
              active: companyActive.value === i
            }]),
            key: c.name,
            onClick: $event => selectCompany(i)
          }, _toDisplayString(c.name), 11, _hoisted_19);
        }), 64))]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(markets, (m, i) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["seg-item", {
              active: active.value === i
            }]),
            key: m.name,
            onClick: $event => selectMarket(i)
          }, _toDisplayString(m.name), 11, _hoisted_22);
        }), 64))]), _createElementVNode("div", {
          class: "pan-trend-btn",
          onClick: openTrend
        }, "📈 查看走势折线图"), _createVNode(_component_var_loading, {
          loading: loading.value,
          description: "加载中"
        }, {
          default: _withCtx(() => [currentList.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [current.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(companies[companyActive.value].name) + " · 当前盘口", 1), _createElementVNode("span", _hoisted_26, _toDisplayString(fmtTime(current.value.value1)), 1)]), _createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCols.value, c => {
            return _openBlock(), _createElementBlock("div", {
              class: "pan-col",
              key: c.key
            }, [_createElementVNode("div", {
              class: _normalizeClass(["pan-current-val", {
                handicap: c.handicap
              }])
            }, _toDisplayString(getVal(current.value, c)), 3), _createElementVNode("div", _hoisted_28, _toDisplayString(c.label), 1)]);
          }), 128))])])) : _createCommentVNode("", true), historyList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCols.value, c => {
            return _openBlock(), _createElementBlock("div", {
              class: "pan-col",
              key: c.key
            }, _toDisplayString(c.label), 1);
          }), 128))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (item, i) => {
            return _openBlock(), _createElementBlock("div", {
              class: "pan-row",
              key: i
            }, [_createElementVNode("div", _hoisted_33, _toDisplayString(fmtTime(item.value1)), 1), _createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCols.value, c => {
              return _openBlock(), _createElementBlock("div", {
                class: "pan-col",
                key: c.key
              }, [_createElementVNode("span", {
                class: _normalizeClass(["pan-val", {
                  handicap: c.handicap
                }])
              }, _toDisplayString(getVal(item, c)), 3), c.trend && trendOf(i, c) !== 'none' ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["pan-arrow", 'arrow-' + trendOf(i, c)])
              }, _toDisplayString(trendOf(i, c) === 'up' ? '▲' : '▼'), 3)) : _createCommentVNode("", true)]);
            }), 128))])]);
          }), 128))])) : _createCommentVNode("", true)], 64)) : !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_35, "暂无盘口数据")) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["loading"])])]))])]),
        _: 1
      }, 8, ["visible"]), _createVNode(HandicapTrendView, {
        ref_key: "trendRef",
        ref: trendRef
      }, null, 512)], 64);
    };
  }
};